var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsFetching } from '@tanstack/react-query';
import cs from 'classnames';
import { LoaderCover } from 'ui-kit/loader';
import { Box } from 'ui-kit/box';
export var LoaderWrapperWithQueryKey = function (_a) {
    var children = _a.children, className = _a.className, classNameWhileLoading = _a.classNameWhileLoading, style = _a.style, queryKeys = _a.queryKeys;
    var loading = !!useIsFetching({ queryKey: queryKeys });
    return (_jsxs(Box, __assign({ className: cs(className, loading ? classNameWhileLoading : undefined), display: "block", position: "relative", style: style }, { children: [loading && _jsx(LoaderCover, {}), children] })));
};
